/*
 * pb-captacion.js — captación del boletín (Photobooth360Store)
 *
 * Dos puntos de entrada al mismo sorteo:
 *   · el pop-up (tres pasos: nombre, email, país)
 *   · el bloque del footer (nombre y email)
 * Se distinguen en el mailing por `punto_captacion`, que es lo que luego dice cuál capta.
 *
 * El COMPORTAMIENTO del pop-up está trasplantado de DreamsTiny, medido leyendo su repo y
 * no la web (docs/mailing/captacion-popup-y-footer.md). El código no: aquello es Astro.
 *
 * Todo se envía al Worker (`/captacion`), NO directamente a la plataforma de mailing: la
 * llave de servicio no puede viajar al navegador, y sin llave la puerta pública devuelve
 * el HTML del formulario en vez de JSON, así que aquí no se distinguiría un alta buena de
 * un descarte.
 *
 * OJO al orden: el pop-up puede estar silenciado y salir antes de tiempo. Por eso cada
 * punto de entrada tiene su propia función; con un solo `return` arriba, silenciar el
 * pop-up dejaba también el footer muerto.
 */
(function () {
  'use strict';

  var DISMISS_KEY = 'pb360_capt_dismissed';
  var DONE_KEY = 'pb360_capt_done';

  // Siete días, no dos minutos. Con el disparador a los 15 s o al 60 % de scroll, un
  // descarte corto significa que quien lee tres páginas se lo come cuatro veces en la
  // misma visita: cerrar es una respuesta, no un «pregúntamelo otra vez dentro de un rato».
  var DISMISS_MS = 7 * 24 * 60 * 60 * 1000;
  var MIN_TIME_MS = 5000;    // nada salta nada más aterrizar
  var SHOW_TIME_MS = 15000;
  var SCROLL_RATIO = 0.6;

  var forzado = false;
  try {
    forzado = new URLSearchParams(window.location.search).has('popup');
  } catch (e) {}

  function silenciado() {
    try {
      if (localStorage.getItem(DONE_KEY)) return true;
      return Date.now() < Number(localStorage.getItem(DISMISS_KEY) || 0);
    } catch (e) {
      // Sin almacenamiento (modo privado, cookies bloqueadas) NO se enseña el pop-up. Es
      // preferible perder un alta a enseñárselo a la misma persona en cada página.
      return true;
    }
  }

  function hecho() {
    try { localStorage.setItem(DONE_KEY, '1'); } catch (e) {}
  }

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  /* Erratas de dominio (gmail.con -> gmail.com). La lista y el Levenshtein estan en
   * `pb-email-typo.js`, compartidos con el formulario de contacto: una sola lista para los
   * tres sitios donde se pide un correo.
   *
   * Devuelve true si hay que FRENAR: hay una sugerencia y todavia no se ha insistido con
   * ese mismo correo. El segundo intento con el mismo valor deja pasar, porque un dominio
   * corporativo legitimo puede quedar a una letra de uno comun y no se puede dejar a nadie
   * fuera para siempre por parecerse a Gmail.
   *
   * Sin el asset compartido no frena nada: es una ayuda, no un requisito. */
  function frenaPorErrata(input, caja, memoria) {
    if (!input || !caja || !window.PBEmailTypo) return false;
    var v = (input.value || '').trim();
    var sugerido = window.PBEmailTypo.sugerir(v);
    if (!sugerido) { window.PBEmailTypo.ocultar(caja); return false; }
    if (memoria.insistido === v) return false; // ya se le aviso y lo mantiene: adelante
    memoria.insistido = v;
    window.PBEmailTypo.pintar(caja, input, caja.getAttribute('data-tpl') || '',
                              caja.getAttribute('data-cta') || '',
                              function () { memoria.insistido = null; });
    return true;
  }

  // Una memoria por formulario: lo que el pop-up ya ha avisado no cuenta para el footer.
  var memoriaTypo = { insistido: null };
  var memoriaTypoPie = { insistido: null };

  // Atribución de primer contacto. La guarda `pipedrive-lead.js` en sessionStorage la
  // primera vez que alguien entra en la web, así que aquí solo se lee: si se volviera a
  // calcular, el anuncio que trajo a la persona se perdería en cuanto navegase una página.
  function atribucion() {
    try {
      return JSON.parse(sessionStorage.getItem('pb360_attr') || '{}');
    } catch (e) {
      return {};
    }
  }

  // Mismo emisor que `pb-cta-lead.js`: gtag y/o dataLayer, lo que haya, y nunca rompe si
  // no hay ninguno. Sin aceptar cookies no se carga ninguna etiqueta de Google, así que
  // esto no dispara nada y tampoco falla.
  function track(evento, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', evento, params || {});
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: evento }, params || {}));
    } catch (e) {}
  }

  function idiomaPagina() {
    return (document.documentElement.getAttribute('lang') || 'es').split('-')[0];
  }

  // Envío común. Devuelve una promesa: quien llama decide qué enseñar.
  function alta(worker, cuerpo) {
    var a = atribucion();
    cuerpo.attrSource = a.attrSource || '';
    cuerpo.attrCampaign = a.attrCampaign || '';
    return fetch(worker + '/captacion', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(cuerpo),
    }).then(function (res) {
      // Sin esto, CUALQUIER respuesta se trataba como éxito: un 429 del limitador por IP o
      // un 422 por email mal formado enseñaban «gracias» sin que nadie se hubiera apuntado.
      // El fetch solo falla por red, no por código de estado.
      if (!res.ok) throw new Error('http ' + res.status);
      return res;
    });
  }

  // ──────────── Teléfono: prefijo, dígitos y validez (compartido) ────────────
  // Lo usan el pop-up y el bloque del footer, que desde el 07/09/2026 también lo pide. Aquí
  // fuera y no dentro de cada init a propósito: son DOS formularios y un solo criterio de
  // qué teléfono vale, igual que hay una sola lista de países (`pb-prefijos-telefono`). El
  // repo ya tiene cicatrices de duplicar justo esto y ver cómo se desincronizan las copias.
  //
  // Se localizan por CLASE dentro de la raíz que se pase, no por id: los ids son distintos
  // en los dos sitios (`pbc-telefono` / `pbf-telefono`) y las clases son las mismas.
  function ccDatos(raiz) {
    var select = raiz.querySelector('select.pbc-tel-cc');
    var opcion = select && select.options[select.selectedIndex];
    if (!select || !opcion) return null;
    return {
      cc: select.value,
      min: parseInt(opcion.getAttribute('data-min'), 10) || 7,
      max: parseInt(opcion.getAttribute('data-max'), 10) || 15,
      z: opcion.getAttribute('data-z') === '1',
    };
  }

  // Digitos nacionales limpios, calcados de `nationalDigits` de `pipedrive-lead.js`: fuera
  // separadores, fuera el prefijo si lo ha repetido delante (+34…, 0034… o 34…) y fuera el
  // 0 inicial en los paises que lo usan (data-z="1": FR 06… → 6…). Sin lo del prefijo
  // repetido, un «+34 600 000 000» bien escrito se leeria como once digitos y se rechazaria.
  function digitosNacionales(bruto, c) {
    var s = String(bruto || '');
    var d = s.replace(/[^0-9]/g, '');
    if (s.indexOf('+') !== -1 && d.indexOf(c.cc) === 0) d = d.slice(c.cc.length);
    else if (d.indexOf('00' + c.cc) === 0) d = d.slice(c.cc.length + 2);
    else if (d.indexOf(c.cc) === 0 && d.length - c.cc.length >= c.min && d.length - c.cc.length <= c.max) d = d.slice(c.cc.length);
    if (c.z && d.charAt(0) === '0') d = d.slice(1);
    return d;
  }

  // «+<prefijo><numero>», o cadena vacia si el numero no vale. El telefono es OBLIGATORIO
  // en los dos formularios (lo pidio Miguel: el 01/09/2026 en el pop-up y el 07/09 en el
  // footer), asi que ese vacio no significa «no lo ha puesto y da igual»: es lo que frena
  // el envio. Se comprueba la longitud contra el data-min/data-max del pais para que un
  // «600» o doce cifras en España no pasen por telefono bueno; un «+34» suelto tampoco, que
  // es un dato que alguien acabaria llamando.
  function telefonoCompuesto(raiz) {
    var campo = raiz.querySelector('input.pbc-tel-num');
    var c = ccDatos(raiz);
    if (!campo || !c) return '';
    var digitos = digitosNacionales(campo.value, c);
    if (digitos.length < c.min || digitos.length > c.max) return '';
    return '+' + c.cc + digitos;
  }

  // ───────────────────────────── Pop-up ──────────────────────────────────────
  function initPopup() {
    var raiz = document.getElementById('pbc-root');
    if (!raiz) return;
    if (!forzado && silenciado()) return;

    var WORKER = raiz.dataset.worker;
    var dialogo = raiz.querySelector('.pbc-dialog');
    var barra = raiz.querySelector('[data-pbc-progreso]');
    var pasos = raiz.querySelectorAll('[data-pbc-paso]');
    var error = raiz.querySelector('[data-pbc-error]');
    var abierto = false;
    var clicsFuera = 0;
    var focoPrevio = null;
    var enviando = false;
    var abiertoEn = Date.now();
    var datos = { nombre: '', email: '', pais: '', telefono: '' };

    function pasoVisible() {
      for (var i = 0; i < pasos.length; i++) {
        if (!pasos[i].hidden) return pasos[i];
      }
      return null;
    }

    function enfocar() {
      var p = pasoVisible();
      if (!p) return;
      // Consulta escalonada a propósito: un selector combinado devolvería el primer
      // <button> del documento, que es la X de cerrar, no el campo del paso.
      var campo = p.querySelector('input:not([type=hidden]):not([type=checkbox])') || p.querySelector('button');
      if (campo) campo.focus({ preventScroll: true });
    }

    function irA(nombre, progreso) {
      for (var i = 0; i < pasos.length; i++) {
        pasos[i].hidden = pasos[i].dataset.pbcPaso !== nombre;
      }
      if (barra) barra.style.width = progreso + '%';
      if (error) error.hidden = true;
      enfocar();
    }

    // El prefijo, los dígitos y la validez del teléfono viven arriba, compartidos con el
    // bloque del footer: un solo criterio para los dos formularios.

    function fallo(texto) {
      if (!error) return;
      error.textContent = texto;
      error.hidden = false;
    }

    var reintento = null;
    function bannerCookiesAbierto() {
      var b = document.querySelector('#shopify-pc__banner');
      if (!b) return false;
      var e = window.getComputedStyle(b);
      return e.display !== 'none' && e.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
    }

    // Capas del tema abiertas (menú móvil, carrito, buscador): el pop-up no se abre
    // encima de ellas. Se vio el 29/10/2026 con el menú móvil desplegado: el diálogo
    // tapaba la navegación. Se reintenta en 4 s, igual que con el banner de cookies.
    function capaAbierta() {
      return !!document.querySelector(
        'header-drawer details[open], cart-drawer.active, #CartDrawer.active, ' +
        'details-modal details[open], quick-add-modal[open], .drawer.active'
      );
    }

    function mostrar() {
      if (abierto) return false;
      // Esta condicion va ANTES de `forzado` y no despues, a proposito: quien ya dejo sus
      // datos no tiene que volver a ver el pop-up ni con `?popup` en la URL. Sin esto, tras
      // completar el alta el DOM se queda en el paso de exito y el siguiente disparador
      // (scroll o salida del puntero) reabria el dialogo enseñando otra vez el "Listo".
      if (raiz.dataset.pbcHecho === '1') return false;
      if (!forzado && silenciado()) return false;
      if (!forzado && Date.now() - abiertoEn < MIN_TIME_MS) return false;
      // FIX-11: con el banner de cookies abierto, esperar y reintentar.
      if (!forzado && (bannerCookiesAbierto() || capaAbierta())) {
        clearTimeout(reintento);
        reintento = setTimeout(mostrar, 4000);
        return false;
      }
      abierto = true;
      clicsFuera = 0;
      focoPrevio = document.activeElement;
      raiz.hidden = false;
      enfocar();
      return true;
    }

    function cerrar(recordar) {
      raiz.hidden = true;
      abierto = false;
      if (recordar) {
        try { localStorage.setItem(DISMISS_KEY, String(Date.now() + DISMISS_MS)); } catch (e) {}
      }
      if (focoPrevio && focoPrevio.focus) focoPrevio.focus({ preventScroll: true });
    }

    // --- Disparadores -------------------------------------------------------
    var temporizador = setTimeout(mostrar, SHOW_TIME_MS);
    if (forzado) mostrar();

    function alHacerScroll() {
      var doc = document.documentElement;
      var ratio = (window.scrollY + window.innerHeight) / doc.scrollHeight;
      if (ratio >= SCROLL_RATIO && mostrar()) window.removeEventListener('scroll', alHacerScroll);
    }
    window.addEventListener('scroll', alHacerScroll, { passive: true });

    // Intención de salida: solo con ratón. En un móvil no existe «sacar el puntero por
    // arriba», y sin este filtro saltaría solo con hacer scroll hacia atrás.
    function alSalirElPuntero(e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia('(pointer: fine)').matches) mostrar();
    }
    document.addEventListener('mouseout', alSalirElPuntero);
    window.addEventListener('pagehide', function () { clearTimeout(temporizador); });

    // Una vez dejados los datos, los disparadores no tienen para qué seguir vivos. La
    // condición de `mostrar()` ya basta; esto es el cinturón, y además deja de calcular el
    // ratio de scroll en cada evento durante el resto de la visita.
    function desmontarDisparadores() {
      clearTimeout(temporizador);
      window.removeEventListener('scroll', alHacerScroll);
      document.removeEventListener('mouseout', alSalirElPuntero);
    }

    // --- Cierre -------------------------------------------------------------
    // La X y Escape cierran a la primera. El clic fuera necesita tres, y los dos primeros
    // dan un empujón: cerrarlo sin mirarlo cuesta algo, sin llegar a ser un patrón oscuro,
    // porque siempre hay dos salidas inmediatas.
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-pbc-cerrar]'), function (b) {
      b.addEventListener('click', function () { cerrar(true); });
    });

    raiz.addEventListener('click', function (e) {
      if (e.target !== raiz) return;
      // Una vez dejados los datos, insistir no tiene sentido: cierra al primer clic.
      if (raiz.dataset.pbcHecho === '1') { cerrar(false); return; }
      clicsFuera += 1;
      if (clicsFuera >= 3) { clicsFuera = 0; cerrar(true); return; }
      if (dialogo) {
        dialogo.classList.remove('pbc-nudge');
        void dialogo.offsetWidth;
        dialogo.classList.add('pbc-nudge');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !raiz.hidden) cerrar(raiz.dataset.pbcHecho !== '1');
    });

    // Trampa de foco: con Tab no se sale del diálogo mientras está abierto.
    raiz.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || raiz.hidden) return;
      var focusables = Array.prototype.filter.call(
        raiz.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var primero = focusables[0];
      var ultimo = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    });

    // --- Pasos --------------------------------------------------------------
    raiz.querySelector('[data-pbc-a-email]').addEventListener('click', function () {
      var v = (raiz.querySelector('#pbc-nombre').value || '').trim();
      if (v.length < 2) { fallo(raiz.dataset.errNombre); return; }
      datos.nombre = v;
      irA('email', 66);
    });

    raiz.querySelector('[data-pbc-a-pais]').addEventListener('click', function () {
      var campoEmail = raiz.querySelector('#pbc-email');
      var v = (campoEmail.value || '').trim();
      if (!EMAIL_RE.test(v)) { fallo(raiz.dataset.errEmail); return; }
      // El formato puede ser impecable y el dominio no existir: `gmaik.com` pasa el regex.
      // Aqui se frena y se ofrece la correccion; insistiendo con el mismo correo, pasa.
      if (frenaPorErrata(campoEmail, raiz.querySelector('#pbc-email-typo'), memoriaTypo)) return;
      // Ya no hay casilla que validar (01/09/2026): el aviso legal va bajo el boton y el
      // envio es la aceptacion. Un formulario con menos que comprobar tambien tiene menos
      // formas de dejar a alguien fuera por un despiste.
      // Obligatorio desde el 01/09/2026, por decision de Miguel: nacio opcional esa misma
      // mañana. Se valida DESPUES del email para no cambiar el orden en que se leen los dos
      // campos, y con el mismo criterio de longitud que el formulario de contacto.
      var tel = telefonoCompuesto(raiz);
      if (!tel) { fallo(raiz.dataset.errTelefono); return; }
      datos.email = v;
      datos.telefono = tel;
      irA('pais', 100);
    });

    var rejilla = raiz.querySelector('.pbc-paises');
    var avisoCargando = raiz.querySelector('[data-pbc-cargando]');
    var botonesPais = Array.prototype.slice.call(raiz.querySelectorAll('[data-pbc-pais]'));

    // Lo que se ve en el MISMO clic, antes de que la red conteste: el país elegido se pinta
    // en ámbar, los otros siete se apagan y aparece el aviso de que se está enviando.
    function marcarElegido(boton) {
      boton.classList.add('es-elegido');
      if (rejilla) rejilla.classList.add('esta-enviando');
      botonesPais.forEach(function (x) { x.disabled = true; });
      if (avisoCargando) {
        avisoCargando.textContent = raiz.dataset.cargando || '';
        avisoCargando.hidden = !avisoCargando.textContent;
      }
    }

    // Y lo que se deshace si la red falla: si no, el pop-up se queda con un país elegido,
    // todo apagado y sin forma de reintentar.
    function soltarEleccion(boton) {
      boton.classList.remove('es-elegido');
      if (rejilla) rejilla.classList.remove('esta-enviando');
      botonesPais.forEach(function (x) { x.disabled = false; });
      if (avisoCargando) avisoCargando.hidden = true;
    }

    botonesPais.forEach(function (b) {
      b.addEventListener('click', function () {
        if (enviando) return;
        enviando = true;
        marcarElegido(b);
        // El valor va SIEMPRE en su literal, aunque la etiqueta esté traducida: el campo
        // de lista del panel compara el texto tal cual, y un valor que no case entra
        // vacío sin dar ningún error.
        datos.pais = b.dataset.pbcPais;
        var trampa = raiz.querySelector('#pbc-x1');
        alta(WORKER, {
          nombre: datos.nombre,
          email: datos.email,
          telefono: datos.telefono,
          pais: datos.pais,
          punto: 'popup',
          origen: window.location.href,
          pb_x1: trampa ? trampa.value : '',
        }).then(function () {
          hecho();
          track('newsletter_subscribe', {
            punto_captacion: 'popup',
            pais: datos.pais,
            idioma: idiomaPagina(),
          });
          raiz.dataset.pbcHecho = '1';
          desmontarDisparadores();
          if (avisoCargando) avisoCargando.hidden = true;
          irA('exito', 100);
          var bloque = raiz.querySelector('[data-pbc-paso="exito"]');
          // Se anuncia y recibe el foco. Y no hay temporizador: nada se cierra solo. Un
          // cierre automático obliga a pausarlo si hay foco dentro, no da tiempo a un
          // lector de pantalla, y WCAG pide poder controlar lo que se cierra solo
          // llevando información.
          if (bloque) bloque.focus({ preventScroll: true });
        }).catch(function () {
          // Si la red falla no se le puede decir «gracias»: no se ha apuntado. Se deja el
          // paso como está para que pueda reintentar y NO se marca como hecho.
          soltarEleccion(b);
          enviando = false;
          fallo(raiz.dataset.errRed);
        });
      });
    });
  }

  // ────────────────────────── Bloque del footer ──────────────────────────────
  // No mira la supresión: es un bloque estático al final de la página, no interrumpe a
  // nadie, y quien cerró el pop-up puede querer apuntarse desde aquí igualmente.
  function initFooter() {
    var seccion = document.querySelector('.pbf');
    if (!seccion) return;

    var form = seccion.querySelector('[data-pbf-form]');
    var exito = seccion.querySelector('[data-pbf-exito]');
    var error = seccion.querySelector('[data-pbf-error]');
    var boton = seccion.querySelector('[data-pbf-enviar]');
    if (!form || !boton) return;

    var WORKER = seccion.dataset.pbfWorker;
    var enviando = false;

    function fallo(texto) {
      if (!error) return;
      error.textContent = texto;
      error.hidden = false;
    }

    boton.addEventListener('click', function () {
      if (enviando) return;
      var n = (seccion.querySelector('#pbf-nombre').value || '').trim();
      var campoEmailPie = seccion.querySelector('#pbf-email');
      var v = (campoEmailPie.value || '').trim();
      if (n.length < 2) { fallo(seccion.dataset.errNombre); return; }
      if (!EMAIL_RE.test(v)) { fallo(seccion.dataset.errEmail); return; }
      if (frenaPorErrata(campoEmailPie, seccion.querySelector('#pbf-email-typo'), memoriaTypoPie)) return;
      // Teléfono obligatorio también aquí desde el 07/09/2026, con el criterio compartido:
      // se valida DESPUÉS del email para que los avisos salgan en el orden en que están los
      // campos, igual que en el pop-up.
      var tel = telefonoCompuesto(seccion);
      if (!tel) { fallo(seccion.dataset.errTelefono); return; }
      if (error) error.hidden = true;
      enviando = true;
      boton.disabled = true;
      // Mismo problema que en el pop-up: el alta tarda y un boton solo deshabilitado no
      // dice nada. Se le cambia el texto y se guarda el original para poder volver.
      var textoOriginal = boton.textContent;
      var textoCargando = seccion.dataset.cargando || '';
      if (textoCargando) boton.textContent = textoCargando;

      var trampa = seccion.querySelector('#pbf-x1');
      alta(WORKER, {
        nombre: n,
        email: v,
        telefono: tel,
        pais: '',
        punto: 'footer',
        origen: window.location.href,
        pb_x1: trampa ? trampa.value : '',
      }).then(function () {
        hecho();
        track('newsletter_subscribe', {
          punto_captacion: 'footer',
          pais: '',
          idioma: idiomaPagina(),
        });
        form.hidden = true;
        if (exito) {
          exito.hidden = false;
          exito.focus({ preventScroll: true });
        }
      }).catch(function () {
        enviando = false;
        boton.disabled = false;
        boton.textContent = textoOriginal;
        fallo(seccion.dataset.errRed);
      });
    });

    // Enter en el campo envía, que es lo que espera cualquiera en un formulario de una
    // sola línea.
    Array.prototype.forEach.call(seccion.querySelectorAll('.pbf-input'), function (campo) {
      campo.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); boton.click(); }
      });
    });
  }

  initPopup();
  initFooter();
})();
